<template>

  <nav class="panel">
    <p class="panel-heading">Bundels</p>

    <div class="panel-block">
      <p class="control has-icons-left">
        <input class="input" type="text"
               placeholder="Zoek op de naam van de bundel of type het id van de bundel voorafgegaan door een # om alleen op het id te zoeken" v-model="query">
        <span class="icon is-small is-left">
          <i class="fas fa-search" aria-hidden="true"></i>
        </span>
      </p>
    </div>

    <router-link
      v-for="bundle in myBundles"
      :key="bundle.id"
      :to="{ name: 'values', params: { bundleId: bundle.id } }"
      class="panel-block">

      <span class="panel-icon">
        <i class="fas fa-briefcase"></i>
      </span>

      <span class="id has-text-weight-bold is-family-monospace">{{ String('&nbsp;&nbsp;&nbsp;&nbsp;' +
        bundle.id).slice(-4) }}</span> {{ bundle.name }}

      <span v-if="bundle.dossier_nr" class="tag is-dark">
        <span class="icon">
          <i class="fas fa-file-alt"></i>
        </span>

        {{ getDossierName(bundle.dossier_nr, bundle.profile_nr) }}
      </span>
    </router-link>
  </nav>

</template>

<script>
import { mapGetters } from 'vuex'
import DossierMixin from '@/mixins/dossiers'

export default {
  data () {
    return {
      query: ''
    }
  },

  mixins: [
    DossierMixin
  ],

  computed: {
    ...mapGetters({
      bundles: 'bundles/bundles',
      dossiers: 'dossiers/dossiers'
    }),

    myBundles () {
      return this.bundles.filter(bundle => {
        if (this.query.charAt(0) === '#') {
          return bundle.id === parseInt(this.query.substr(1))
        }

        const a = `${bundle.id} ${bundle.name.toLowerCase()}`

        return a.includes(this.query.toLowerCase())
      })
    }
  },

  created () {
    this.$store.dispatch('dossiers/loadAll')
  },

  watch: {
    dossiers () {
      if (this.dossiers.length > 0) {
        this.bundles.forEach((bundle) => {
          if (bundle.dossier_nr && bundle.profile_nr) {
            bundle.dossier_name = this.getDossierName(bundle.dossier_nr, bundle.profile_nr)
          }
        })
      }
    }
  },

  // methods: {
  //   getDossier (dossierNr) {
  //     return this.dossiers.find(dossier => parseInt(dossier.nr) === dossierNr)
  //   },
  //
  //   getProfile (dossier, profileNr) {
  //     return dossier.profielen.find(profiel => parseInt(profiel.nr) === profileNr)
  //   },
  //
  //   getCrebo (crebos) {
  //     return crebos.map(crebo => crebo.nr).join(', ')
  //   },
  //
  //   getDate (crebos) {
  //     return crebos.map(crebo => crebo.valid_from).join(', ')
  //   },
  //
  //   getDossierName (dossierNr, profileNr) {
  //     if (this.dossiers.length > 0) {
  //       const dossier = this.getDossier(dossierNr)
  //       const profile = this.getProfile(this.getDossier(dossierNr), profileNr)
  //
  //       return `${dossier.titel} (${this.getCrebo(dossier.crebos)})/${profile.titel} (${this.getCrebo(profile.crebos)}) vanaf ${this.getDate(profile.crebos)}`
  //     }
  //   }
  // }
}
</script>

<style scoped>
  .id {
    margin-right: 15px;
  }
  a .tag {
    margin: 0 0 0 10px;
  }
</style>
